export enum Environment {
  PROD = "prod",
  QA = "stg",
  PROTO = "dev",
  LOCAL = "local",
}

const urls: { accountUrl: string; activateUrl: string; ssoUrl: string } = {
  [Environment.PROD]: {
    accountUrl: "https://account.ui.com",
    activateUrl: "https://activate.ui.com",
    ssoUrl: "https://sso.ui.com",
  },
  [Environment.QA]: {
    accountUrl: "https://account.stg.ui.com",
    activateUrl: "https://activate.stg.ui.com",
    ssoUrl: "https://sso.stg.ui.com",
  },
  [Environment.PROTO]: {
    accountUrl: "https://account.dev.ui.com",
    activateUrl: "https://activate.dev.ui.com",
    ssoUrl: "https://sso.dev.ui.com",
  },
  [Environment.LOCAL]: {
    accountUrl: "https://account.dev.ui.com",
    activateUrl: "https://activate.local.ui.com",
    ssoUrl: "https://sso.dev.ui.com",
  },
}[import.meta.env.VITE_NODE_CONFIG_ENV as Environment];

export const app: {
  env: Environment;
  sentryAuthToken?: string;
  accountUrl: string;
  activateUrl: string;
  ssoUrl: string;
} = {
  env: import.meta.env.VITE_NODE_CONFIG_ENV as Environment,
  ...urls,
};
